$(document).on 'ready turbolinks:load', ->
  if $('#workplace_payment_details_show').length > 0 && $('#detail_verification_button').length > 0 && $('.alert.alert-info').length > 0
    window.open($('#detail_verification_button').attr('href'), '_blank').focus()
$(document).on 'ready turbolinks:load', ->
  if $('#workplace_payment_details_show').length > 0 && $('#detail_verification_button').length > 0 && $('.alert.alert-info').length > 0
    window.open($('#detail_verification_button').attr('href'), '_blank').focus()
